import FireMedallion from "../../../core/assets/oot/gshd/red-medallion_32x32.png"
import Item from "../../../core/items/Item"
import { ItemLightDto } from "../../../core/items/ItemDataTypes"
import DoubleMedallionItem from "./DoubleMedallionItem"
import { DbMedallionsProps, MedallionProps } from "./MedallionInterface"
import MedallionItem from "./MedallionItem"

export const id = "Fire Medallion"

const FireMedallionItem = (props: MedallionProps) => {

    return <MedallionItem
        image={FireMedallion}
        id={id}
        hideLabel={props.hideLabel}
        mixedpool={props.mixedPool}
        isObtained={props.isObtained}
        setIsObtained={props.setIsObtained}
        labelIndex={props.indexLabel}
        setLabelIndex={props.setIndexLabel}
    />
}

export default FireMedallionItem


export const DoubleFireMedallion = () => {
    return <DoubleMedallionItem
        image={FireMedallion}
        id={id}
    />
}


export const SimpleFireMedallionItem = (props: MedallionProps) => {

    return <Item
    image={FireMedallion}
    isObtained={true}
    id={id}
    onClick={() => { }}
    title={id}
/>

}


export const DbFireMedallionItem = (props: DbMedallionsProps) => {

    let item = props.items?.filter(x => x.id === id)?.[0] ?? DefaultFireMedallionItem;

    return <MedallionItem
        image={FireMedallion}
        id={id}
        hideLabel={props.hideLabel}
        mixedpool={props.mixedPool}
        isObtained={props.isObtained}
        item={item}
        updateItem={props.update}
    />
}

export const DefaultFireMedallionItem : ItemLightDto = {

    img: FireMedallion,
    id: id,
    title: id,
    childItem: undefined,
    childItemName: undefined,
    isObtained: false,
    isChecked: false,
    state: 0
}